const CPQ_APP_SEGMENT = /\/apps\/cpq(?:\/|$)/;

export function isCpqAppPath(pathname: string): boolean {
  return CPQ_APP_SEGMENT.test(pathname);
}
